import CryptoJS from 'crypto-js';


export const GetItemFromStorage = (key: any) => {
  const initialValue = null;
  if (typeof window === "undefined") {
    return initialValue;
  }
  try {
    const item: any = window?.localStorage.getItem(key);
    const secretKey: any = import.meta.env.VITE_APP_LOCAL_STORAGE_SECRET_KEY;
    const decrypted: any = CryptoJS.AES.decrypt(item, secretKey).toString(CryptoJS.enc.Utf8);
    if (decrypted) {
      return JSON.parse(decrypted);
    } else {
      localStorage.clear();
      sessionStorage.clear();
      const host = window.location.hostname;
      const domainParts = host.split(".");
      domainParts.shift();
      const domain = domainParts.join(".");
      document.cookie.split(";").forEach((ck) => {
        document.cookie = ck
          .replace(/^ +/, "")
          .replace(
            /=.*/,
            "=;expires=" + new Date().toUTCString() + ";path=/" + domain
          );
      });
      window.location.href = '/login';
      return item && item !== 'undefined' ? JSON.parse(item) : initialValue;
    }
  } catch (error) {
    console.error(error);
    return initialValue;
  }
};

export const SetItemInStorage = (key: any, value: any) => {
  try {
    if (typeof window !== "undefined") {
        const secretKey: any = import.meta.env.VITE_APP_LOCAL_STORAGE_SECRET_KEY;
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), secretKey).toString();
        window.localStorage.setItem(key, encrypted);
    }
       
  } catch (error) {
    console.error(error);
  }
};

export const setTokenEncrypt = (value: any) => {
  try {
    if (typeof window !== "undefined") {
        const secretKey: any = import.meta.env.VITE_APP_CAMPAIGN_KEY;
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), secretKey).toString();
        return encrypted
      } 
       return ""
  } catch (error) {
    return ''
    console.error(error);
  }
};

export const setTokenDecrypt = (value: any) => {
  try {
    if (typeof window !== "undefined") {
        const secretKey: any = import.meta.env.VITE_APP_CAMPAIGN_KEY;
        const decrypted = CryptoJS.AES.decrypt(JSON.stringify(value), secretKey)
        return decrypted;
    }  
  } catch (error) {
    console.error(error);
    return ''
  }
};

export const ClearStorage = () => {
  try {
    if (typeof window !== "undefined") {
      window.localStorage.clear();
    }
  } catch (error) {
    console.error(error);
  }
};


export class Cookie {
  static host = window.location.hostname;

  static set(name: any, value: any, days: any) {
    var domain, domainParts, date: any, expires;

    if (days) {
      date = new Date();

      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }

    if (this.host.split(".").length === 1) {
      document.cookie = name + "=" + value + expires + "; path=/";
    } else {
      domainParts = this.host.split(".");

      domainParts.shift();

      domain = domainParts.join(".");

      document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain;
    }
  }

  static get = () => {
    return document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce((accumulator, [key, value]) => {
        if (key.trim()) return { ...accumulator, [key.trim()]: decodeURIComponent(value) };
        else return "";
      }, {});
  };

  static clear = () => {
    const host = window.location.hostname;

    const domainParts = host.split(".");

    domainParts.shift();

    const domain = domainParts.join(".");

    document.cookie = "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "roleId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "stateChange=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "userDetials=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "workStatus=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "userEmail=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "MY_APP_STATE=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "agentExt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "RememberMe=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "ssoToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "dashboardTour=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
  };
}
